<div class="container-fluid">
  <div class="row">
    <p>Vous allez effectuer un export de la table <b>{{tab.entite}}</b></p>
    <br><br>
    <hr>
  </div>

  <div class="row">
    <div class="col">
      <mat-form-field appearance="outline" style="display:inline-block;width:auto;font-size:10px;">
        <mat-label>Type de fichier</mat-label>
        <mat-select name="selectedType" [(ngModel)]="selectedType">
          <mat-option *ngFor="let type of types" [value]="type.value">{{ type.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <hr>
  </div>

  <div class="row" *ngIf="inProgress">
    <div class="col">
      <p class="mb-2">({{progress}}%) En cours...</p>
      <div class="progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [ngStyle]="{ 'width': progress + '%' }"></div>
      </div>
      <br>
      <hr>
    </div>
  </div>

  <div class="row"> 
    <div class="col-lg-6">
      <button type="button" class="btn-secondary-light" mat-raised-button (click)="onClose()">ANNULER</button>
    </div>
    <div class="col-lg-6 text-end">
      <button [disabled]="inProgress" type="button" class="btn-secondary" mat-raised-button (click)="onExport(0)">
        <span *ngIf="inProgress"><mat-spinner [diameter]="14" style="display:inline-block;"></mat-spinner>&nbsp;&nbsp;</span>EXPORTER
      </button>
    </div>
  </div>
</div>
